export enum StatusOrcamentoEnum {
  Orcando = 0,
  Aprovado = 1,
  Reprovado = 2
}

export const StatusOrcamentoLabels: { [key in StatusOrcamentoEnum]: string } = {
  [StatusOrcamentoEnum.Orcando]: 'Orçando',
  [StatusOrcamentoEnum.Aprovado]: 'Aprovado',
  [StatusOrcamentoEnum.Reprovado]: 'Reprovado'
};

